import React from "react";
import { PageHeroAnchorLinkType } from "../types/PageHeroAnchor";
import Select from "../Select/Select";
import { CtaButton } from "../Cta/cta-button";

const PageHeroAnchorLink: React.FC<PageHeroAnchorLinkType> = ({
  headline,
  subCopy,
  ctaCopy,
  ctaUrl,
  ctaLink,
  image,
  linkSection,
  onClick,
}) => {
  const options = linkSection?.map(item => ({
    id: item?.ctaUrl,
    label: item?.ctaCopy,
  }));

  let emptyLinkSection = true;
  if (linkSection?.[0]) {
    emptyLinkSection = Object.keys(linkSection[0]).length === 0;
  }

  return (
    <div className="page-hero-anchor bg-sun-100 md:overflow-x-visible overflow-x-hidden">
      <div className="page-hero-anchor__container max-w-desktop mx-[auto] py-[48px] lg:mx-[40px] md:py-[96px]  md:pb-[40px] md:ml-[40px] sm:pt-[80px] sm:mx-[20px] sm:pb-[32px]">
        <div className="flex justify-between gap-[40px] items-center md:flex-col-reverse md:pl-0 md:gap-[64px] md:p-0">
          <div className="max-w-[520px] md:max-w-full">
            <h1
              className={
                subCopy
                  ? "page-hero-anchor__font-set page-hero-anchor__title mb-xs"
                  : "page-hero-anchor__font-set page-hero-anchor__title md:mb-7 mb-11"
              }
            >
              {headline}
            </h1>
            {subCopy && (
              <p className="page-hero-anchor__font-set body--text-extra-large md:mb-8 mb-11">
                {subCopy}
              </p>
            )}
            <div className="flex mt-1">
              {ctaCopy && (
                <CtaButton
                  copy={ctaCopy}
                  copySize="bodyRegular"
                  isDisabled={false}
                  link={ctaLink?.value?.data?.url || null}
                  linkUrl={ctaUrl || null}
                  variant="primarySun"
                  onClick={onClick}
                />
              )}
            </div>
          </div>
          <div className="page-hero-anchor__image-container max-w-full">
            <picture className="page-hero-anchor__image relative max-w-full h-auto object-contain overflow-visible md:overflow-hidden md:w-auto md:h-auto md:max-h-[396px]">
              <source srcSet={image?.mobile} media="(max-width: 639px)" />
              <source srcSet={image?.tablet} media="(max-width: 1023px)" />
              <img
                src={image?.desktop}
                alt={image?.imageAltText}
                className="page-hero-anchor__image-src md:mx-auto"
              />
            </picture>
          </div>
        </div>
        {!emptyLinkSection && (
          <div className="flex items-center w-full justify-center gap-[24px] pl-0 pr-0 pt-[80px] md:pt-[64px] md:pb-0 md:pl-0 md:pr-0 sm:flex-col sm:gap-[16px]">
            <p className="page-hero-anchor__font-set body--text-medium">
              Explore our features by benefit:
            </p>
            <div className="flex items-center gap-[8px] md:hidden">
              {linkSection?.map((item, key) => {
                return (
                  <CtaButton
                    copy={item?.ctaCopy}
                    copySize="bodyRegular"
                    isDisabled={false}
                    link={item?.ctaUrl}
                    linkUrl={null}
                    variant="secondaryForest"
                    className="button-hero-link"
                    onClick={onClick}
                    key={key}
                  />
                );
              })}
            </div>
            <div className="hidden md:block">
              <Select
                options={options}
                backgroundColor="#FFFAEB"
                onChange={value => {
                  return (window.location.href = value as string);
                }}
                position="popper"
                className="border-[1.5px] border-none text-[--forest-900] page--hero__select--custom"
                defaultValue={linkSection?.[0]?.ctaUrl}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeroAnchorLink;
